"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPC;

function isPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  var flag = true;
  var isSafari = userAgentInfo.indexOf('Safari') != -1 && userAgentInfo.indexOf('Version') != -1; // 判断是否为ipad pro

  if (isSafari && userAgentInfo.indexOf('Macintosh') && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
    return false;
  }

  for (var v = 0; v < Agents.length; v += 1) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }

  return flag;
}